import React from 'react';
import PropTypes from 'prop-types';
import { TROPHY_CONFIG } from '../../../../services/utilityFunctions';
import translate from '../../../../commonComponents/translate';

function JourneyStatsTrophy({ t, trophy }) {
  return (
    <div key={trophy} className="journey-overall-stats-awards">
      <div className="journey-overall-stats-awards-item">
        <img src={TROPHY_CONFIG[trophy].imageURL} alt="trophy" />
        <h6>{t(TROPHY_CONFIG[trophy].translationKey)}</h6>
      </div>
    </div>
  );
}

JourneyStatsTrophy.propTypes = {
  t: PropTypes.func.isRequired,
  trophy: PropTypes.string.isRequired,
};

export default translate(JourneyStatsTrophy);
